<template>
  <div class="shadow-component rounded-t-10 rounded-b-10">
    <h3
      class="flex items-center py-base px-twenty mb-0 rounded-t-10 text-16 !font-body cursor-default"
      :class="{
        'bg-widgetHeader text-black  !font-normal': variant === 'default',
        'bg-warning text-whiteOverride !font-bold': variant === 'warning'
      }"
      data-test="title"
    >
      <FailIndicator
        v-if="variant === 'warning'"
        class="!inline-flex mr-sm !bg-transparent border-solid border-2 border-whiteOverride"
      />
      <slot name="title" />
    </h3>
    <div
      class="bg-whiteOverride p-twenty rounded-b-10 border-solid"
      :class="{
        'border-1 border-t-0 border-primaryBorder': variant === 'default',
        'border-3 border-warning': variant === 'warning'
      }"
    >
      <div
        class="widget-content mb-twenty"
        data-test="content"
      >
        <slot name="content" />
      </div>
      <div data-test="cta">
        <slot name="cta" />
      </div>
    </div>
  </div>
</template>

<script>
import FailIndicator from '@/components/library/indicators/FailIndicator.vue';

export default {
  name: 'SidebarWidget',
  props: {
    variant: {
      type: String,
      required: false,
      default() {
        return 'default';
      },
      validator(value) {
        return ['default', 'warning'].includes(value);
      },
    },
  },
  components: { FailIndicator },
};
</script>

<style scoped>
.widget-content p {
  @apply text-14 text-dark3 leading-1.5
}
</style>
